var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepas(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 6.75C21.9142 6.75 22.25 7.08578 22.25 7.5C22.25 7.91422 21.9142 8.25 21.5 8.25H20.7705L19.4072 15.5166C19.2188 16.5216 18.3417 17.2498 17.3193 17.25H7.30566C6.2833 17.2498 5.40623 16.5216 5.21777 15.5166L3.85449 8.25H2.5C2.08579 8.25 1.75 7.91421 1.75 7.5C1.75 7.08579 2.08579 6.75 2.5 6.75H21.5ZM6.69141 15.2402C6.74681 15.5356 7.00509 15.7498 7.30566 15.75H17.3193C17.6199 15.7498 17.8782 15.5357 17.9336 15.2402L19.2441 8.25H5.38086L6.69141 15.2402Z",
    fill: "#A1A7AD",
    stroke: "#A1A7AD",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepas);
export default __webpack_public_path__ + "static/media/repas.7185af0093743bb424e48a227df192ec.svg";
export { ForwardRef as ReactComponent };